import {Injectable} from "@angular/core";
import {MDTMeetingsProxy} from "./mdt.meetings.proxy";
import {Observable} from "rxjs";
import {
	IMDTMeetingCancellation,
	IMDTMeetingOrderingOrg, IMDTMeetingsAddRequest,
	IMDTMeetingsCalendarContentResponse, IMDTMeetingsCancellationRequest,
	IMDTMeeting,
	IMDTMeetingsFavoritesDataResponse, IMDTMeetingsMoveRequest, IMDTMeetingsRemoveRequest, IMDTMeetingSequenceIDRequest
} from "../interfaces/mdt.meetings.interface";
import {INode} from "../interfaces/mdt.meetings.interface";
import {HttpObservable} from "../../../common/http/services";
import {IMDTMeetingsAvailableIn} from "../interfaces/mdt.meetings.interface";
import {IMDTMeetingsWorklistInput} from "../../../app/shell/session/components/mdt.meetings.worklist/interfaces/mdt.meetings.worklist.interface";

@Injectable({ providedIn: 'root' })
  export class MDTMeetingsService {

	constructor(private proxy: MDTMeetingsProxy) {
	}

	public getMDTMeetingsFavoritesData(): Observable<IMDTMeetingsFavoritesDataResponse>{
		return this.proxy.getMDTMeetingsFavoritesData();
	}
	public getMDTMeetingsCurrentUserOrganizationsRoot(): Observable<INode>{
		return this.proxy.getMDTMeetingsCurrentUserOrganizationsRoot();
	}

	public getFavoritesMDTMeetingsOrgStructureTree(): Observable<INode> {
		return this.proxy.getFavoritesMDTMeetingsOrgStructureTree();
	}

	public getMDTMeetingsAvailableInList(siteWorklistKey): Observable<IMDTMeetingsAvailableIn[]> {
		return this.proxy.getMDTMeetingsAvailableInList(siteWorklistKey);
	}

	public getMDTMeetingOrganizationStructure(organizationStructureKey): Observable<string>{
		return this.proxy.getMDTMeetingOrganizationStructure(organizationStructureKey);
	}

	public getMDTMeetingOrderingOrgs(conferenceKey): Observable<IMDTMeetingOrderingOrg[]>{
		return this.proxy.getMDTMeetingOrderingOrgs(conferenceKey);
	}

	public getMDTMeetingScheduled(conferenceKey: number){
		return this.proxy.getMDTMeetingScheduled(conferenceKey);
	}

	public getMDTMeetingCalendarContent(conferenceKey, date): Observable<IMDTMeetingsCalendarContentResponse>{
		return this.proxy.getMDTMeetingCalendarContent(conferenceKey, date);
	}

	public getMDTMeetingCancellationByYear(conferenceKey, date): Observable<IMDTMeetingCancellation[]>{
		return this.proxy.getMDTMeetingCancellationByYear(conferenceKey, date);
	}

	public addMDTMeetingFavorite(favoriteMeeting: IMDTMeeting): Observable<void> {
		return this.proxy.addMDTMeetingFavorite(favoriteMeeting);
	}

	public removeMDTMeetingFavorite(favoriteMeeting: IMDTMeeting): Observable<void> {
		return this.proxy.removeMDTMeetingFavorite(favoriteMeeting);
	}

	public setDefaultFavoriteMeeting(defaultFavoriteMeetingKey: number): Observable<void> {
		return this.proxy.setDefaultFavoriteMeeting(defaultFavoriteMeetingKey);
	}

	public getMeetingWorklistRowsNumberByDate(conferenceKey, date): Observable<number>{
		return this.proxy. getMeetingWorklistRowsNumberByDate(conferenceKey, date);
	}

	public getMDTMeetingFromConferenceKey(conferenceKey): Observable<IMDTMeeting>{
		return this.proxy.getMDTMeetingFromConferenceKey(conferenceKey);
	}

	public cancelOccurrence(cancellationRequest: IMDTMeetingsCancellationRequest): HttpObservable<void> {
		return this.proxy.cancelOccurrence(cancellationRequest);
	}

	public addToMDTMeeting(addMDTMeetingRequest: IMDTMeetingsAddRequest): HttpObservable<void> {
		return this.proxy.addToMDTMeeting(addMDTMeetingRequest);
	}

	public moveToMDTMeeting(moveMDTMeetingRequest: IMDTMeetingsMoveRequest): HttpObservable<void> {
		return this.proxy.moveToMDTMeeting(moveMDTMeetingRequest);
	}

	public removeFromMDTMeeting(removeMDTMeetingRequest: IMDTMeetingsRemoveRequest[]): HttpObservable<void> {
		return this.proxy.removeFromMDTMeeting(removeMDTMeetingRequest);
	}

	public setStudySequenceIDInMDTMeetingWorklist(request: IMDTMeetingSequenceIDRequest, changeSingleWorklistRow: boolean): HttpObservable<void> {
		return this.proxy.setStudySequenceIDInMDTMeetingWorklist(request, changeSingleWorklistRow);
	}

	public getWorklistMeetingDate(worklistInput: IMDTMeetingsWorklistInput) {
		return worklistInput?.filter?.find(x=>x.dynamicDateValue!=null)?.dynamicDateValue;
	}
}
